import { request, METHOD } from '../utils/request.js'

// 查看是否有准考证
export function checkOrder(data) {
  return request(
    '/h5Mfitness/parent/checkOrder',
    METHOD.POST,
    data
  )
}
// 学年体制测试列表
export function getYearList(data) {
    return request(
      '/h5Mfitness/parent/getYearList',
      METHOD.POST,
      data
    )
  }
  // 获取预约信息
export function getOrderList(data) {
    return request(
      '/h5Mfitness/parent/getOrderList',
      METHOD.POST,
      data
    )
  }
    // 预约
export function orderBySnCode(data) {
    return request(
      '/h5Mfitness/parent/orderBySnCode',
      METHOD.POST,
      data
    )
  }
      // 取消预约
export function unOrderBySnCode(data) {
    return request(
      '/h5Mfitness/parent/unOrderBySnCode',
      METHOD.POST,
      data
    )
  }
  